/**
 * Document visual components
 *
 * Pure DOM-based visuals for document blocks (text, headers, sections, etc.)
 */

// Container visuals (render children)
export { DocumentVisual } from './DocumentVisual'
export { SectionVisual } from './SectionVisual'
